export enum SemanaRepeticao {
    "1ª" = 1,
    "2ª" = 2,
    "3ª" = 3,
    "4ª" = 4,
    "Última" = 5,
  }